import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { OTChecklist, OTChecklistData } from '../../../interfaces/OT/OT-Checklist';
import { OTChecklistApi } from '../api/OT-Checklist.api';

@Injectable() 
export class OTChecklistService extends OTChecklistData{
 
  constructor(private api: OTChecklistApi) {
    super();
  } 
  
  getall(url: string): Observable<OTChecklist[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<OTChecklist>{
      return this.api.getby_id(url);
  }

  create(url: string, data:OTChecklist): Observable<OTChecklist[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:OTChecklist): Observable<OTChecklist> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
